var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { Icons } from 'src/ui/components/Icons/Icons';
import { E_ICONS } from 'src/ui/components/Icons/constants';
import styles from './loader.module.scss';
import { IDENTIFIER_LOADER } from 'src/ui/components/Loader/constants';
export var Loader = function (props) {
    var className = props.className;
    var logoClassName = classNames(styles.loader, className);
    return (_jsx("div", __assign({ "data-test": IDENTIFIER_LOADER, className: styles.loaderWrapper }, { children: _jsx(Icons, { icon: E_ICONS.QUICKSIGN, className: logoClassName }) })));
};
